export default "__VITE_ASSET__DzoHdaXT__"